import type { HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

export const standardCardVariants = cva(
  'standard-card rounded-2xl border text-[var(--standard-ink,#17151a)] transition-[border-color,box-shadow,transform] duration-200',
  {
    variants: {
      variant: {
        default: 'border-[var(--standard-line,#d7dcdf)] bg-[var(--standard-paper,#fcfbf8)] shadow-[0_8px_24px_rgba(23,21,26,0.04)]',
        elevated: 'border-[var(--standard-line-strong,#bcc5ca)] bg-[var(--standard-paper,#fcfbf8)] shadow-[0_16px_40px_rgba(23,21,26,0.08)]',
        command: 'border-[#c7d3d8] bg-[var(--standard-paper,#fcfbf8)] shadow-[0_14px_34px_rgba(23,21,26,0.06)]',
        metric: 'border-[var(--standard-line,#d7dcdf)] bg-[var(--standard-paper,#fcfbf8)]',
        faith: 'border-[var(--standard-line,#d7dcdf)] border-l-[3px] border-l-[var(--standard-bronze,#b28a49)] bg-[var(--standard-paper,#fcfbf8)]',
        interactive: 'border-[var(--standard-line,#d7dcdf)] bg-[var(--standard-paper,#fcfbf8)] shadow-[0_8px_24px_rgba(23,21,26,0.04)] hover:-translate-y-0.5 hover:border-[var(--standard-steel,#2f5d73)] hover:shadow-[0_14px_30px_rgba(47,93,115,0.1)]',
        warning: 'border-[#d8c69f] bg-[#fbf7ed]',
        destructive: 'border-[#d8b7b2] bg-[#fbf3f2]',
      },
      padding: {
        none: '',
        compact: 'p-3',
        default: 'p-4 sm:p-5',
        spacious: 'p-5 sm:p-7',
      },
    },
    defaultVariants: { variant: 'default', padding: 'default' },
  },
);

export interface StandardCardProps extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof standardCardVariants> {}

export function StandardCard({ variant, padding, className, ...props }: StandardCardProps) {
  return <div className={cn(standardCardVariants({ variant, padding }), className)} {...props} />;
}
